import React from 'react';
import './App.css';
import TestCompatibilidad from './components/TestCompatibilidad/TestCompatibilidad';

// Materia-ui
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#F52F41',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <TestCompatibilidad/>
    </ThemeProvider>
  );
}

export default App;
